import { Injectable } from '@angular/core';
import moment from 'moment';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  isTokenValid(): boolean {
    const token = localStorage.getItem('token');
    if (token) {
      const expiration = JSON.parse(localStorage.getItem('expires_at') || '""');
      return moment().isBefore(moment(expiration));
    }
    return false;
  }

  getToken(): string | undefined {
    return this.isTokenValid() ? localStorage.getItem('token') || '' : undefined;
  }

  setToken(token: string | null): void {
    if (token) {
      localStorage.setItem('token', token);
    }
  }

  clearToken(): void {
    localStorage.removeItem('token');
  }

  removeAll(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('userDetails');
  }

  setUser(user: User): void {
    localStorage.setItem('userDetails', JSON.stringify(user));
  }

  getUser(): User | null {
    const user = localStorage.getItem('userDetails');
    return user ? (JSON.parse(user) as User) : null;
  }
}
